"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateContactDto = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const create_address_dto_1 = require("../../address/dto/create-address.dto");
const contact_details_dto_1 = require("./contact-details.dto");
const professional_experience_dto_1 = require("./professional-experience.dto");
const qualification_experience_dto_1 = require("./qualification-experience.dto");
const contact_document_dto_1 = require("./contact-document.dto");
const create_contact_communication_details_dto_1 = require("./create-contact-communication-details.dto");
const common_1 = require("@nestjs/common");
const constants_1 = require("../../../../../../../libs/service-lib/src/lib/constants");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
class CreateContactDto {
}
exports.CreateContactDto = CreateContactDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Salutation id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "salutationLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "First name is required." }),
    (0, class_validator_1.IsString)({ message: "First name must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "First name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Last name is required." }),
    (0, class_validator_1.IsString)({ message: "Last name must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Last name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Middle name must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Middle name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "middleName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Display name must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Display name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Company id is required." }),
    (0, class_validator_1.IsInt)({ message: "Company id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Company Location id is required." }),
    (0, class_validator_1.IsInt)({ message: "Company Location id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "companyLocationId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Company Branch id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "companyBranchId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Tag id is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "tagLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateIf)((contact) => contact.contactRecordTypeLid === constants_1.COMPANY_CONTACT_RECORD_TYPE),
    (0, class_validator_1.IsNotEmpty)({ message: "Contact type id is required." }),
    (0, class_validator_1.IsInt)({ message: "Contact type id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "contactTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "department must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "department should not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "department", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "designation must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "designation should not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "reporting id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "reportingToId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "relationship type id must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "relationshipTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Contact remarks must be a string." })
    // @Transform(({ value }: { value: string }) =>  value ? value.trim() : value)
    ,
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 1000) {
            throw new common_1.BadRequestException("Contact remarks must not exceed 1000 characters");
        }
        return value;
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateContactDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateContactDto.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Status ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "LinkedIn URL must be a string." }),
    (0, class_validator_1.Matches)(/^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/, {
        message: "Invalid LinkedIn URL format.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateContactDto.prototype, "linkedInUrl", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Contact record type id is required." }),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateContactDto.prototype, "contactRecordTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_address_dto_1.CreateAddressDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateContactDto.prototype, "address", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)({ each: false }),
    (0, class_transformer_1.Type)(() => contact_details_dto_1.CreateContactDetailsDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof contact_details_dto_1.CreateContactDetailsDto !== "undefined" && contact_details_dto_1.CreateContactDetailsDto) === "function" ? _c : Object)
], CreateContactDto.prototype, "contactDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: false }),
    (0, class_transformer_1.Type)(() => professional_experience_dto_1.CreateProfessionalExperienceDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateContactDto.prototype, "professionalExperiences", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: false }),
    (0, class_transformer_1.Type)(() => qualification_experience_dto_1.CreateQualificationExperienceDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateContactDto.prototype, "qualificationExperiences", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: false }),
    (0, class_transformer_1.Type)(() => contact_document_dto_1.CreateContactDocMapDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateContactDto.prototype, "contactDocMaps", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: false }),
    (0, class_transformer_1.Type)(() => create_contact_communication_details_dto_1.CreateContactCommunicationDetailsDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateContactDto.prototype, "communicationDetails", void 0);
